import { inject } from '@angular/core';
import { CanActivateChildFn } from '@angular/router';
import { OnlineGameHelper } from '@dc-core/dc-helpers/online-game.helper';
import { isPublicHeadToHeadPreGame } from 'src/app/core/online-play/utils/online-game-format.utils';

import { OnlinePlayPreGameService } from '../services/online-play-pre-game.service';

export const activeLobbyGuard: CanActivateChildFn = (route) => {
    const preGameService = inject(OnlinePlayPreGameService);
    const preGame = preGameService.currentPreGame();
    if (!preGame) return true;

    const path = route.pathFromRoot.flatMap((part) => part.url.map((segment) => segment.path)).join('/');
    if (
        path === 'online-gameplay-setup' &&
        preGame.status === 'assembling' &&
        isPublicHeadToHeadPreGame(preGame) &&
        preGameService.isOwner() &&
        !preGameService.isFull()
    ) {
        return true;
    }
    if (preGame.status === 'assembling' && path !== 'pre-game' && !preGameService.canBrowseWhileAssembling()) {
        return false;
    }

    const startsLocalGame =
        path.startsWith('game/') ||
        path.startsWith('local-tournament-game/') ||
        (path.startsWith('local-games/') && path !== 'local-games/party-games');
    const startsOnlineGame =
        path === 'online-gameplay-setup' ||
        (path.startsWith('online-game/') &&
            !path.includes('/spectate/') &&
            !(
                preGame.online_game_id &&
                path === OnlineGameHelper.getGameRoute(preGame.gameplay_settings.game_mode, preGame.online_game_id)
            ));

    return !(startsLocalGame || startsOnlineGame) || preGameService.canStartAnotherGame();
};
